/* ================================================================================================
   CAPINI KIT — construtor de kit/bundle 100% nativo (zero app)
   Canal SITE (Steve Jobs) · 11/08/2026 · spec: K1 Anibal 07/08 (padrao AN-99)

   PRINCIPIOS DE SEGURANCA (herdados de snippets/capini-personalization.liquid, 05/08):
   - tudo em try/catch: se este arquivo falhar, a PDP e o ATC nativo seguem intactos;
   - trava de duplo-clique PROPRIA — MEDIDO em 05/08 que o botao de ATC deste tema NUNCA fica
     `disabled`, e 2 toques com 400ms colocam 2 itens no carrinho;
   - o refresh da gaveta usa `cart:refresh`, que e o evento que este tema ja escuta.
   ================================================================================================ */
(function () {
  'use strict';

  if (window.__capiniKitLoaded) return;
  window.__capiniKitLoaded = true;

  /* ---------------------------------------------------------------------------- dinheiro ----- */
  function formatMoney(cents, format) {
    try {
      var value = (cents || 0) / 100;
      var fmt = format || '€{{amount}}';

      function withDelims(num, precision, thousands, decimal) {
        var n = num.toFixed(precision);
        var parts = n.split('.');
        var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return parts[1] ? intPart + decimal + parts[1] : intPart;
      }

      var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
      var token = match ? match[1] : 'amount';
      var out;

      switch (token) {
        case 'amount_no_decimals':               out = withDelims(value, 0, ',', '.'); break;
        case 'amount_with_comma_separator':      out = withDelims(value, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': out = withDelims(value, 0, '.', ','); break;
        case 'amount_with_space_separator':      out = withDelims(value, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': out = withDelims(value, 0, ' ', ','); break;
        case 'amount_with_apostrophe_separator': out = withDelims(value, 2, "'", '.'); break;
        default:                                 out = withDelims(value, 2, ',', '.');
      }
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2);
    }
  }

  /* -------------------------------------------------------------------- o elemento do kit ----- */
  class CapiniKit extends HTMLElement {
    connectedCallback() {
      // 11/09: atributo que o Clarity/Hotjar REGISTRAM (o :defined eles nao enxergam; gravacao saia sem kit e sem botao)
      this.setAttribute('data-ck-ready', '');
      try { this.init(); } catch (e) { /* degrada em silencio: a PDP continua funcionando */ }
    }

    init() {
      if (this.__ready) return;
      this.__ready = true;

      this.moneyFormat = this.dataset.moneyFormat || '€{{amount}}';
      this.afterAdd    = this.dataset.afterAdd || 'drawer';
      this.cartUrl     = this.dataset.cartUrl || '/cart';
      this.showSavings = this.dataset.showSavings === 'true';
      // textos do cliente vem do editor (schema) — nada hardcoded aqui
      this.txtSave    = this.dataset.labelSave       || 'You save';
      this.txtAdded   = this.dataset.labelAdded      || 'Added ✓';
      this.txtErrPick = this.dataset.labelErrPick    || 'Please choose an available option for each item.';
      this.txtErrGen  = this.dataset.labelErrGeneric || 'We could not add this. Please try again.';
      this.txtSaveShort = this.dataset.labelSaveShort || 'SAVE';
      this.txtPerItem   = this.dataset.labelPerItem   || 'each';
      this.txtGanchoFree = this.dataset.labelHookFree || '';
      this.txtGanchoLeva = this.dataset.labelHookGives || '';
      this.txtSegunda    = this.dataset.secondLabel || '';
      this.txtSegundaHook= this.dataset.secondHook || '';
      this.descSegunda   = parseFloat(this.dataset.secondDiscount || '0') || 0;
      this.txtSegundaBadge = this.dataset.secondBadge || '';
      this.cardsMode   = this.dataset.layout === 'cards';
      this.checklist   = this.dataset.layout === 'checklist';
      this.panelBox    = this.querySelector('[data-ck-panel]');

      // ---- barra de progresso ate o frete gratis ----
      this.progOn     = this.dataset.progressOn === 'true';
      this.progTarget = Math.round(parseFloat(this.dataset.progressTarget || '80') * 100);
      this.progAfter  = this.dataset.progressAfterDiscount === 'true';
      // A loja tem um desconto automatico de 5% em TUDO que o widget nao ve. Sem descontar ele
      // aqui, a barra dizia "faltam EUR11" quando o Shopify ainda ia cobrar frete (medido 12/08).
      this.progStorePct = parseFloat(this.dataset.progressStorePct || '0') || 0;
      this.txtAway    = this.dataset.progressAway || 'You are {x} away from free shipping';
      this.txtDone    = this.dataset.progressDone || 'Free shipping unlocked';
      this.progBox    = this.querySelector('[data-ck-progress]');

      // ---- ofertas por produto (so ligam DEPOIS do desconto existir no Shopify) ----
      this.dealsOn      = this.dataset.dealsOn === 'true';
      this.dealProduct  = String(this.dataset.dealProduct || '');
      this.dealPrice    = Math.round(parseFloat(this.dataset.dealPrice || '9.99') * 100);
      this.dealBadge    = this.dataset.dealBadge || 'HALF PRICE';
      this.dealFreeTrig = String(this.dataset.dealFreeTrigger || '');
      this.dealFreeBadge= this.dataset.dealFreeBadge || 'FREE';
      this.txtLosing    = this.dataset.labelLosing || '';
      this.autoMatchOn = this.dataset.autoMatch !== 'false';
      this.txtInherited= this.dataset.labelInherited || 'matched to your';
      this.choicesBox  = this.querySelector('[data-ck-choices]');

      this.tiers   = Array.prototype.slice.call(this.querySelectorAll('.capini-kit__tier'));
      this.ctaWrap = this.querySelector('[data-ck-cta]');
      this.cta     = this.ctaWrap ? (this.ctaWrap.querySelector('button') || this.ctaWrap) : null;
      this.ctaTotal= this.querySelector('[data-ck-cta-total]');
      this.errorEl = this.querySelector('[data-ck-error]');
      this.footSave= this.querySelector('[data-ck-foot-save]');
      this.busy    = false;

      if (!this.tiers.length) return;

      // pre-carrega as variantes de cada item
      this.tiers.forEach(function (tier) {
        tier.querySelectorAll('[data-ck-item]').forEach(function (item) {
          var tag = item.querySelector('script[data-ck-variants]');
          try { item.__variants = JSON.parse(tag.textContent); } catch (e) { item.__variants = []; }
          item.__selected = Number(item.dataset.defaultVariant) || (item.__variants[0] && item.__variants[0].id);
        });
      });

      /* 10/09/2026: a 2a unidade e o MESMO produto do heroi. Antes ela carregava uma copia inteira
         das variantes (68 KB na Milano); agora le a lista do heroi. Sem heroi, a linha sai da tela
         e da conta: melhor sem oferta que com uma linha que poe variante errada no carrinho. */
      this.querySelectorAll('[data-ck-item][data-ck-reuse="hero"]').forEach(function (seg) {
        var sel = '[data-ck-item][data-hero="true"][data-product-id="' + seg.dataset.productId + '"]';
        var tierSeg = seg.closest('.capini-kit__tier');
        var h = (tierSeg && tierSeg.querySelector(sel)) || this.querySelector(sel);
        if (h && h.__variants && h.__variants.length) {
          seg.__variants = h.__variants;
          seg.__selected = Number(seg.dataset.defaultVariant) || h.__variants[0].id;
        } else {
          seg.__variants = []; seg.__semDados = true; seg.hidden = true;
        }
      }, this);
      // as cores da gaveta (nome + foto) vem prontas do servidor
      this.querySelectorAll('[data-ck-cores]').forEach(function (cx) {
        var tag = cx.querySelector('script[data-ck-cores-json]');
        try { cx.__cores = JSON.parse(tag.textContent); } catch (e) { cx.__cores = []; }
      });
      this.vigiaTravaDeModelo();

      // selecao de tier
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click',  this.onClick.bind(this));

      // se ninguem veio pre-selecionado, marca o primeiro
      var checked = this.querySelector('.capini-kit__radio:checked');
      if (!checked) {
        var first = this.querySelector('.capini-kit__radio');
        if (first) first.checked = true;
      }

      this.setupChecklist();
      this.ajustaSegundaUnidade();
      this.syncHeroFromForm();
      this.autoMatch();
      this.watchMainForm();
      this.renderAll();
      this.hideNativeAtc();
    }

    /* ------------------------------------------------ o heroi segue o seletor nativo da PDP --- */
    mainForm() {
      if (this.__form !== undefined) return this.__form;
      // o form de produto do tema (Impact usa form= por atributo, entao busca global)
      this.__form = document.querySelector('form[action*="/cart/add"]') || null;
      return this.__form;
    }

    currentHeroVariant() {
      try {
        var f = this.mainForm();
        if (!f) return null;
        var id = new FormData(f).get('id');
        return id ? Number(id) : null;
      } catch (e) { return null; }
    }

    syncHeroFromForm() {
      var vid = this.currentHeroVariant();
      if (!vid) return;
      this.querySelectorAll('[data-ck-item][data-hero="true"]').forEach(function (item) {
        var found = (item.__variants || []).some(function (v) { return v.id === vid; });
        if (found) item.__selected = vid;
      });
    }

    watchMainForm() {
      var self = this;
      var f = this.mainForm();
      if (!f) return;
      // qualquer mudanca dentro do form nativo (radio de cor, select, swatch) reflete aqui
      f.addEventListener('change', function () {
        setTimeout(function () { self.syncHeroFromForm(); self.autoMatch(); self.renderAll(); }, 30);
      });
      // o tema tambem troca a variante pela URL (?variant=) sem disparar change no form
      window.addEventListener('popstate', function () {
        setTimeout(function () { self.syncHeroFromForm(); self.autoMatch(); self.renderAll(); }, 30);
      });
    }

    /* ------------------------------------------------------------------------ interacoes ----- */
    onChange(ev) {
      var t = ev.target;
      if (t.matches('[data-ck-variant]')) {
        var item = t.closest('[data-ck-item]');
        if (item) item.__selected = Number(t.value);
      }
      if (t.matches('[data-ck-modelo]')) {
        var segS = t.closest('[data-ck-item]');
        if (segS) { segS.__modeloProprio = t.value; if (segS.dataset.slot === 'second') this.ligaLinha(segS); }
      }
      this.renderAll();
    }

    onClick(ev) {
      var abre = ev.target.closest && ev.target.closest('[data-ck-gaveta-abre]');
      if (abre) {
        ev.preventDefault();
        var segG = abre.closest('[data-ck-item]');
        if (segG) {
          if (this.__gaveta && this.__gaveta.botao === abre) this.fechaGaveta();
          else this.abreGaveta(segG, abre);
        }
        return;
      }
      var acao = ev.target.closest && ev.target.closest('[data-ck-modelo-acao]');
      if (acao) {
        ev.preventDefault();
        var segM = acao.closest('[data-ck-item]');
        if (segM) {
          if (acao.dataset.ckModeloAcao === 'troca') {
            segM.__modeloProprio = segM.__modeloAtual || null;
          } else {
            segM.__modeloProprio = null;
          }
        }
        this.renderAll();
        return;
      }

      var pill = ev.target.closest && ev.target.closest('[data-ck-variant-pill]');
      if (pill) {
        ev.preventDefault();
        var item = pill.closest('[data-ck-item]');
        if (item) {
          item.__selected = Number(pill.dataset.variantId);
          item.querySelectorAll('[data-ck-variant-pill]').forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          // clicar numa pill tambem escolhe o tier dela
          var radio = pill.closest('.capini-kit__tier').querySelector('.capini-kit__radio');
          if (radio) radio.checked = true;
        }
        this.renderAll();
        return;
      }

      var chip = ev.target.closest && ev.target.closest('[data-ck-chip]');
      if (chip) {
        ev.preventDefault();
        var pid = chip.dataset.product, vid = Number(chip.dataset.variant);
        this.querySelectorAll('[data-ck-item][data-slot="main"][data-product-id="' + pid + '"]').forEach(function (it) {
          it.__selected = vid;
          var sel = it.querySelector('[data-ck-variant]');
          if (sel) sel.value = String(vid);
        });
        this.renderAll();
        return;
      }

      if (this.checklist) {
        var linha = ev.target.closest && ev.target.closest('[data-ck-item]');
        if (linha && !ev.target.closest('[data-ck-variant], [data-ck-variant-pill], [data-ck-link], [data-ck-cores], [data-ck-modelo], [data-ck-modelo-linha]')) {
          ev.preventDefault();
          this.toggleItem(linha);
          return;
        }
      }

      if (ev.target.closest && ev.target.closest('[data-ck-cta]')) {
        ev.preventDefault();
        this.addToCart();
      }
    }


    /* ---------------------------------------------- CASAMENTO AUTOMATICO DE VARIANTE ---------
       O cliente ja disse qual iPhone ele tem no seletor da pagina. Perguntar de novo pra pelicula
       e friccao — e, pior, o padrao do produto vinha ERRADO: capa "iPhone 17" com pelicula
       "iPhone 17 Pro Max" (medido no rascunho em 11/08, antes deste conserto).

       MEDIDO em 11/08: os 10 modelos da capa batem EXATO com os nomes de variante da pelicula
       (iPhone 17, iPhone 17 Pro, iPhone 16 Pro Max...). Nao precisa de tabela de-para: o titulo
       da variante do complemento e comparado com os valores de opcao do heroi.

       O que nao casa (ex.: AirPods Pro 3 x Pro 2) continua sendo PERGUNTA — vira chip na linha
       de escolhas, fora dos cards.
    */
    heroOptionValues() {
      var hero = this.querySelector('[data-ck-item][data-hero="true"]');
      if (!hero) return [];
      var v = this.variantOf(hero);
      if (!v || !v.title) return [];
      return v.title.split('/').map(function (x) { return x.trim(); }).filter(Boolean);
    }

    autoMatch() {
      if (!this.autoMatchOn) return;
      var vals = this.heroOptionValues();
      this.querySelectorAll('[data-ck-item][data-hero="false"]').forEach(function (item) {
        if (item.querySelector('[data-ck-cores]')) { item.dataset.matched = 'false'; return; }   // 10/09: item com gaveta se resolve em itensGaveta()
        var lista = (item.__variants || []).filter(function (v) { return v.available; });
        var hit = null;
        for (var i = 0; i < lista.length && vals.length; i++) {
          if (vals.indexOf((lista[i].title || '').trim()) > -1) { hit = lista[i]; break; }
        }
        if (hit) {
          item.__selected = hit.id;
          item.dataset.matched = 'true';
          var sel = item.querySelector('[data-ck-variant]');
          if (sel) sel.value = String(hit.id);
        } else {
          item.dataset.matched = 'false';
        }
      });
    }

    /* ------------------------------------------------- a linha de escolhas (layout cards) ---- */
    renderChoices() {
      var box = this.choicesBox;
      if (!box) return;
      // No checklist a variante ja vive DENTRO da linha do produto. Repetir aqui embaixo era o
      // "aparece em dois locais" que o Talles pegou em 11/08.
      if (this.checklist) { box.innerHTML = ''; return; }
      var tier = this.querySelector('.capini-kit__tier.is-selected');
      if (!tier) { box.innerHTML = ''; return; }

      var self = this, html = '', herdado = '';

      tier.querySelectorAll('[data-ck-item]').forEach(function (item) {
        if (item.dataset.hero === 'true') return;
        if (item.querySelector('[data-ck-cores]')) return;   // 10/09: item com gaveta nao vira chip
        var nome = (item.dataset.shortName || '').trim();

        if (item.dataset.matched === 'true') {
          var v = self.variantOf(item);
          if (v && !herdado) herdado = self.txtInherited + ' ' + v.title;
          return;
        }
        var opcoes = (item.__variants || []).filter(function (v) { return v.available; });
        if (opcoes.length < 2) return;

        // o rotulo do produto sai: os proprios chips ja dizem "AirPods Pro 3" / "Pro 2".
        // So entra quando o valor da variante NAO se explica sozinho (ex.: "S", "M", "L").
        var precisaRotulo = opcoes.some(function (v) { return (v.title || '').trim().length < 8; });
        if (precisaRotulo && nome) {
          html += '<span class="capini-kit__choice-label">' + nome + '</span>';
        }
        opcoes.forEach(function (v) {
          var on = v.id === item.__selected;
          html += '<button type="button" class="capini-kit__chip" data-ck-chip data-product="' +
                  item.dataset.productId + '" data-variant="' + v.id + '" aria-pressed="' + on + '">' +
                  v.title + '</button>';
        });
      });

      if (herdado) html += '<span class="capini-kit__inherited">' + herdado + '</span>';
      box.innerHTML = html;
    }

    /* ------------------------------------------------------- o kit e o unico botao de compra --
       Escondido POR JS, de proposito: se este arquivo falhar, o botao nativo continua na tela e
       a loja segue vendendo. Esconder por CSS deixaria a pagina sem botao nenhum num erro de JS.
    */
    hideNativeAtc() {
      if (this.dataset.replaceNativeAtc !== 'true') return;
      try {
        // ARMADILHA (12/08, no ar): querySelector com LISTA de seletores devolve o primeiro do
        // DOCUMENTO, nao o primeiro SELETOR. O `<buy-buttons>` interno aparece antes no DOM que o
        // wrapper `.product-info__buy-buttons`, entao eu escondia o elemento errado e o botao
        // nativo continuava na tela. Mesmo furo cravado no lessons.md em 11/08 (`#of-modal textarea`).
        /* 🔴 13/08 — O CAMPO DE PERSONALIZAÇÃO SUMIU DA MILANO, E FUI EU.
           `snippets/buy-buttons.liquid` renderiza `capini-personalization` DENTRO do mesmo
           <form>, como IRMÃO do <buy-buttons>. Esconder o wrapper `.product-info__buy-buttons`
           levava a personalização junto — o cliente perdia o monograma em folha de ouro, que é
           justamente o que separa a Capini de uma capa qualquer.
           Agora escondo SÓ o <buy-buttons>. Tudo que é irmão dele continua na tela. */
        var wrap = document.querySelector('.product-info__buy-buttons');
        var alvo = (wrap && wrap.querySelector('buy-buttons'))
                || document.querySelector('buy-buttons')
                || wrap;
        if (alvo && !alvo.contains(this)) alvo.style.display = 'none';
      } catch (e) {}
    }


    /* ------------------------------------------------------- LAYOUT CHECKLIST (opcao 2) -------
       Aqui nao existe "escolher entre conjuntos": existe a capa (fixa) e cada extra que o cliente
       liga ou desliga. O desconto aparece NA LINHA do produto, que foi o pedido do Talles em
       11/08 ("os descontos ainda nao tao claros").
       O tier com MAIS itens vira a fonte; os outros somem. Assim a mesma configuracao do editor
       serve os dois layouts, sem duplicar nada.
    */
    setupChecklist() {
      if (!this.checklist) return;
      var maior = null, max = -1;
      this.tiers.forEach(function (t) {
        var n = t.querySelectorAll('[data-ck-item]').length;
        if (n > max) { max = n; maior = t; }
      });
      if (!maior) return;
      this.tiers.forEach(function (t) {
        if (t !== maior) t.hidden = true;
      });
      var radio = maior.querySelector('.capini-kit__radio');
      if (radio) radio.checked = true;
      this.sourceTier = maior;
      // MARTELO do Talles 12/08: "deixa desmarcado as opcoes da pelicula e do AirPods, e marcado
      // so a capinha, pra propria pessoa marcar". So o heroi nasce ligado (e travado).
      var pre = this.dataset.preselectAddons === 'true';
      maior.querySelectorAll('[data-ck-item]').forEach(function (item) {
        var heroi = item.dataset.hero === 'true';
        item.__on = heroi ? true : pre;
        if (heroi) item.dataset.locked = 'true';
        item.dataset.on = item.__on ? 'true' : 'false';
      });
    }

    toggleItem(item) {
      if (!this.checklist) return;
      if (item.dataset.locked === 'true') return;   // a capa nao se desmarca
      if (item.dataset.gift === 'true') return;     // o brinde tambem nao: ele e gratis
      item.__on = !item.__on;
      item.dataset.on = item.__on ? 'true' : 'false';
      this.renderAll();
    }

    itensAtivos(tier) {
      var todos = Array.prototype.slice.call(tier.querySelectorAll('[data-ck-item]')).filter(function (i) { return !i.__semDados; });
      if (!this.checklist) return todos;
      return todos.filter(function (i) { return i.__on !== false; });
    }

    /* --------------------------------------------- PAINEL DE DETALHE (layout cards) ----------
       "deveria aparecer mais detalhes dos produtos, a depender da opcao que a pessoa escolher"
       — Talles, 11/08. Lista os itens da opcao ESCOLHIDA com nome, variante e preco.
    */
    renderPanel() {
      var box = this.panelBox;
      if (!box || !this.cardsMode) return;
      var tier = this.querySelector('.capini-kit__tier.is-selected');
      if (!tier) { box.innerHTML = ''; return; }
      var self = this, disc = Number(tier.dataset.discount) || 0, html = '';

      tier.querySelectorAll('[data-ck-item]').forEach(function (item) {
        var v = self.variantOf(item);
        if (!v) return;
        var qty = Number(item.dataset.qty) || 1;
        var img = item.querySelector('.capini-kit__item-img');
        var nome = (item.dataset.shortName || '').trim();
        var linha = v.title && v.title !== 'Default Title' ? v.title : '';
        var cheio = v.price * qty;
        var final = disc > 0 ? Math.round(cheio * (100 - disc) / 100) : cheio;

        html += '<div class="capini-kit__panel-row">' +
                (img ? '<img class="capini-kit__panel-img" src="' + img.getAttribute('src') + '" alt="" width="28" height="28" loading="lazy">' : '') +
                '<span class="capini-kit__panel-name">' + (qty > 1 ? qty + '× ' : '') + nome +
                (linha ? ' <span class="capini-kit__panel-variant">' + linha + '</span>' : '') + '</span>' +
                '<span class="capini-kit__panel-price">' +
                (final < cheio ? '<s>' + formatMoney(cheio, self.moneyFormat) + '</s> ' : '') +
                formatMoney(final, self.moneyFormat) + '</span>' +
                '</div>';
      });
      box.innerHTML = html;
    }


    /* ------------------------------------------------------ OFERTA: preco efetivo do item -----
       O Talles (11/08): "pelicula metade do preco com a capa; se levar o AirPods, sai de graca".
       Estes precos sao os que o CLIENTE VE. Quem cobra e o desconto automatico do Shopify —
       por isso `deals_enabled` nasce DESLIGADO: ligar sem o desconto criado faz a pagina
       prometer o que o checkout nao cumpre.
    */
    dealPriceFor(item, ativos) {
      if (!this.dealsOn) return null;
      if (String(item.dataset.productId) !== this.dealProduct) return null;
      // o gatilho do brinde esta marcado? entao a peca sai de graca
      var temGatilho = ativos.some(function (i) {
        return String(i.dataset.productId) === this.dealFreeTrig;
      }, this);
      return temGatilho ? 0 : this.dealPrice;
    }

    /* ------------------------------------------------------------ BARRA DE FRETE GRATIS ------
       O limite JA EXISTE na loja (EUR80). A barra so conta pro cliente onde ele esta — nao cria
       promessa nova. `progress_after_discount` decide se mede o valor cheio ou o ja descontado;
       so o checkout real diz qual dos dois o Shopify usa.
    */
    brutoDoTier(tier) {
      var t = 0, self = this;
      this.itensAtivos(tier).forEach(function (item) {
        var v = self.variantOf(item);
        if (v) t += (typeof item.__unit === 'number' ? item.__unit : v.price) * (Number(item.dataset.qty) || 1);
      });
      return t;
    }

    renderProgress(totalCents) {
      if (!this.progOn || !this.progBox) return;
      var texto = this.progBox.querySelector('[data-ck-progress-text]');
      var fill  = this.progBox.querySelector('[data-ck-progress-fill]');
      var falta = this.progTarget - totalCents;
      var pct   = Math.max(0, Math.min(100, Math.round(totalCents / this.progTarget * 100)));

      if (fill) fill.style.width = pct + '%';
      this.progBox.classList.toggle('is-done', falta <= 0);
      if (!texto) return;

      if (falta <= 0) {
        texto.innerHTML = this.txtDone;
      } else {
        texto.innerHTML = this.txtAway.replace('{x}', formatMoney(falta, this.moneyFormat));
      }
    }


    /* ------------------------------------------------- O BRINDE NAO E ESCOLHA ---------------
       BUG PEGO PELO TALLES em 12/08, no ar: com capa + AirPods marcados e a pelicula
       DESMARCADA, a tela mostrava "LIVRE" na pelicula mas o botao dizia "Adicionar 2 itens".
       O cliente adicionava 2 e PERDIA o brinde que a pagina acabara de prometer.

       Regra: se o gatilho do brinde esta no carrinho, o presente entra junto, marcado e travado.
       Tirou o gatilho, o presente volta EXATAMENTE ao estado em que o cliente o tinha deixado —
       nao herda a marcacao forcada, que seria empurrar um item de EUR11 sem ele pedir.
    */
    aplicaBrindeObrigatorio(tier) {
      if (!this.dealsOn || !this.dealProduct || !this.dealFreeTrig) return;

      var gat = tier.querySelector('[data-ck-item][data-slot="main"][data-product-id="' + this.dealFreeTrig + '"]');
      var pre = tier.querySelector('[data-ck-item][data-slot="main"][data-product-id="' + this.dealProduct + '"]');
      if (!gat || !pre) return;

      var gatilhoAtivo = gat.__on !== false;

      if (gatilhoAtivo) {
        if (pre.__on === false) {
          pre.__estadoAntes = false;        // lembra que ELE tinha deixado desmarcado
          pre.__on = true;
          pre.dataset.on = 'true';
        }
        pre.dataset.gift = 'true';          // trava: brinde nao se desmarca
      } else {
        if (pre.dataset.gift === 'true' && pre.__estadoAntes === false) {
          pre.__on = false;                 // devolve o estado original, sem empurrar
          pre.dataset.on = 'false';
        }
        pre.__estadoAntes = undefined;
        pre.dataset.gift = 'false';
      }
    }


    /* ---------------------------------------------- SEGUNDA UNIDADE (a 4a linha) -------------
       MEDIDO em 12/08 sobre 433 pedidos: quem leva 2 do mesmo produto leva a MESMA COR em
       iPhones DIFERENTES (10 de 12). Entao a linha abre assim — mesma cor, outro modelo — e
       deixa os dois seletores livres. Quem quer outra cor troca; quem quer presentear so
       escolhe o modelo. Eu nao escolho por ele, mas nao comeco no caso raro.
    */
    ajustaSegundaUnidade() {
      var self = this;
      this.querySelectorAll('[data-ck-item][data-slot="second"]').forEach(function (seg) {
        if (seg.querySelector('[data-ck-cores]')) return;   // 10/09: a linha com gaveta se resolve em itensGaveta()
        var hero = self.querySelector('[data-ck-item][data-hero="true"]');
        if (!hero) return;
        var vh = self.variantOf(hero);
        if (!vh || seg.__ajustado) return;

        var partes = (vh.title || '').split('/').map(function (x) { return x.trim(); });
        var cor = partes[0];
        var alvo = (seg.__variants || []).filter(function (v) {
          return v.available && v.id !== vh.id && (partes.length < 2 || v.title.indexOf(cor) === 0);
        })[0];
        if (!alvo) {
          alvo = (seg.__variants || []).filter(function (v) { return v.available && v.id !== vh.id; })[0];
        }
        if (alvo) {
          seg.__selected = alvo.id;
          var sel = seg.querySelector('[data-ck-variant]');
          if (sel) sel.value = String(alvo.id);
        }
        seg.__ajustado = true;
      });
    }

    /* ------------------------------------------ 2a UNIDADE EM GAVETA (10/09/2026) ------------
       Esboco A, martelo do Talles depois de reprovar a fileira de fotos no ar:
       - a linha fica do tamanho da dos AirPods: miniatura (a cor escolhida) + botao com o NOME;
       - o botao abre a GAVETA com foto + nome de cada cor (celular: sobe de baixo; computador: embaixo do botao);
       - COR pre-marcada: a 1a da lista; se o cliente ja tem essa la em cima, a 2a. Clicou, a escolha dele manda.
         (Contado 10/09 sobre 36 pedidos com 2 capas iguais: mesmo modelo + outra cor 12, identicas 7.)
       - MODELO copiado do heroi; "Different model?" abre a lista do proprio produto.
       - Trava de modelo pendente: a linha pede o modelo.
       - Combinacao esgotada: a cor aparece riscada na gaveta e o botao do kit recusa. */
    valOpcao(v, i) { return (v && v.o && i >= 0) ? v.o[i] : null; }

    dispSegunda(seg, cor, modelo, ci, mi) {
      var lista = seg.__variants || [];
      for (var i = 0; i < lista.length; i++) {
        var v = lista[i];
        if (v.available && this.valOpcao(v, ci) === cor && (mi < 0 || this.valOpcao(v, mi) === modelo)) return v;
      }
      return null;
    }

    itensGaveta() {
      var self = this;
      var pendente = document.documentElement.hasAttribute('data-capini-model-pendente');
      this.querySelectorAll('[data-ck-item] [data-ck-cores]').forEach(function (caixa) {
        var item = caixa.closest('[data-ck-item]');
        if (!item || item.__semDados || item.dataset.hero === 'true') return;
        var segunda = item.dataset.slot === 'second';
        var ci = Number(caixa.dataset.ckCorIdx), mi = Number(caixa.dataset.ckModIdx);
        var tierIt = item.closest('.capini-kit__tier');
        var hero = (tierIt && tierIt.querySelector('[data-ck-item][data-hero="true"]')) || self.querySelector('[data-ck-item][data-hero="true"]');
        var vh = hero ? self.variantOf(hero) : null;
        var atual = self.variantOf(item);
        var outra = null;
        if (mi >= 0) {
          if (item.__modeloProprio) outra = item.__modeloProprio;
          else if (segunda) outra = self.valOpcao(vh, mi);
          else {
            // complemento: se a outra opcao dele tem um valor igual a um do heroi (ex.: o modelo do iPhone), segue o heroi
            var valsHeroi = (vh && vh.o) || [];
            var lista = item.__variants || [];
            for (var k = 0; k < lista.length && !outra; k++) {
              var x = self.valOpcao(lista[k], mi);
              if (x && valsHeroi.indexOf(x) > -1) outra = x;
            }
            if (!outra) outra = self.valOpcao(atual, mi);
          }
        }
        var cores = (caixa.__cores || []).map(function (c) { return c.v; });
        var alvo = item.__cor ? self.dispSegunda(item, item.__cor, outra, ci, mi) : null;
        if (!alvo && !item.__cor) {
          if (segunda) {
            var corHeroi = self.valOpcao(vh, ci);
            for (var i = 0; i < cores.length && !alvo; i++) {
              if (cores[i] !== corHeroi) alvo = self.dispSegunda(item, cores[i], outra, ci, mi);
            }
            if (!alvo && corHeroi) alvo = self.dispSegunda(item, corHeroi, outra, ci, mi);
          } else {
            alvo = self.dispSegunda(item, self.valOpcao(atual, ci), outra, ci, mi);
            for (var j = 0; j < cores.length && !alvo; j++) alvo = self.dispSegunda(item, cores[j], outra, ci, mi);
          }
        }
        item.__semVariante = !alvo;
        if (alvo) item.__selected = alvo.id;
        item.__corAtual = alvo ? self.valOpcao(alvo, ci) : item.__cor;
        item.__modeloAtual = outra;
        var nome = item.querySelector('[data-ck-cor-nome]');
        if (nome && item.__corAtual && nome.textContent !== item.__corAtual) nome.textContent = item.__corAtual;
        if (segunda) {
          self.linhaModelo(item, mi >= 0, outra, pendente);
        } else {
          var selO = item.querySelector('[data-ck-modelo]');
          if (selO && outra && selO.value !== outra) selO.value = outra;
        }
      });
    }

    linhaModelo(seg, temModelo, modelo, pendente) {
      var linha = seg.querySelector('[data-ck-modelo-linha]');
      var sel = seg.querySelector('[data-ck-modelo]');
      if (!linha) return;
      if (!temModelo) { linha.hidden = true; if (sel) sel.hidden = true; return; }
      if (sel) {
        if (sel.hidden === !!seg.__modeloProprio) sel.hidden = !seg.__modeloProprio;
        if (seg.__modeloProprio && sel.value !== modelo) sel.value = modelo;
      }
      var estado = seg.__modeloProprio ? 'proprio' : (pendente ? 'pendente' : 'heroi');
      var chave = estado + '|' + (modelo || '');
      if (linha.__chave === chave) return;      // nao reescreve o DOM a toa
      linha.__chave = chave;
      var d = linha.dataset;
      linha.textContent = '';
      linha.classList.toggle('is-pendente', estado === 'pendente');
      if (estado === 'proprio') {
        linha.appendChild(this.botaoModelo(d.txtSame || 'Same as mine', 'volta'));
      } else if (estado === 'pendente') {
        linha.appendChild(document.createTextNode(d.txtPick || 'Choose your model above first'));
      } else {
        linha.appendChild(document.createTextNode((d.txtFor || 'For') + ' '));
        var forte = document.createElement('strong');
        forte.textContent = modelo || '';
        linha.appendChild(forte);
        linha.appendChild(document.createTextNode(' · '));
        linha.appendChild(this.botaoModelo(d.txtDiff || 'Different model?', 'troca'));
      }
    }

    botaoModelo(txt, acao) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'capini-kit__modelo-acao';
      b.setAttribute('data-ck-modelo-acao', acao);
      b.textContent = txt;
      return b;
    }

    // escolher cor ou modelo na linha da 2a unidade e intencao de levar: a linha liga sozinha
    ligaLinha(seg) {
      if (!this.checklist || seg.dataset.locked === 'true') return;
      if (seg.__on === false) { seg.__on = true; seg.dataset.on = 'true'; }
    }

    /* A GAVETA mora no <body> enquanto aberta (fora do <label> do kit e de qualquer ancestral com transform)
       e sai do DOM ao fechar. Nada fica escutando a pagina com ela fechada. */
    abreGaveta(seg, botao) {
      var self = this;
      this.fechaGaveta();
      var caixa = seg.querySelector('[data-ck-cores]');
      if (!caixa) return;
      var ci = Number(caixa.dataset.ckCorIdx), mi = Number(caixa.dataset.ckModIdx);
      var celular = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
      var titulo = caixa.dataset.ckTitulo || 'Colour';

      var g = document.createElement('div');
      g.className = 'capini-kit-gaveta ' + (celular ? 'is-celular' : 'is-computador');
      var fundo = document.createElement('div');
      fundo.className = 'capini-kit-gaveta__fundo';
      var painel = document.createElement('div');
      painel.className = 'capini-kit-gaveta__painel';
      painel.setAttribute('role', 'dialog');
      painel.setAttribute('aria-label', titulo);
      var topo = document.createElement('div');
      topo.className = 'capini-kit-gaveta__topo';
      var tt = document.createElement('span');
      tt.className = 'capini-kit-gaveta__titulo';
      tt.textContent = titulo;
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'capini-kit-gaveta__x';
      x.setAttribute('aria-label', 'Close');
      x.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.6" fill="none"></path></svg>';
      topo.appendChild(tt); topo.appendChild(x);

      var lista = document.createElement('div');
      lista.className = 'capini-kit-gaveta__lista';
      lista.setAttribute('role', 'listbox');
      lista.setAttribute('aria-label', titulo);
      (caixa.__cores || []).forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'capini-kit-gaveta__opcao';
        b.setAttribute('role', 'option');
        b.setAttribute('aria-selected', c.v === seg.__corAtual ? 'true' : 'false');
        if (!self.dispSegunda(seg, c.v, seg.__modeloAtual, ci, mi)) { b.disabled = true; b.classList.add('is-esgotada'); }
        if (c.i) {
          var im = document.createElement('img');
          im.src = c.i; im.alt = ''; im.width = 44; im.height = 44; im.decoding = 'async';
          b.appendChild(im);
        } else {
          var sf = document.createElement('span'); sf.className = 'capini-kit-gaveta__semfoto'; b.appendChild(sf);
        }
        var nm = document.createElement('span'); nm.className = 'capini-kit-gaveta__nome'; nm.textContent = c.v; b.appendChild(nm);
        var ck = document.createElement('span'); ck.className = 'capini-kit-gaveta__check'; ck.setAttribute('aria-hidden', 'true'); b.appendChild(ck);
        b.addEventListener('click', function (ev) {
          ev.preventDefault(); ev.stopPropagation();
          seg.__cor = c.v;
          if (seg.dataset.slot === 'second') self.ligaLinha(seg);   // complemento nao liga sozinho: escolher cor nao e pedir o item
          self.fechaGaveta();
          self.renderAll();
        });
        lista.appendChild(b);
      });
      painel.appendChild(topo); painel.appendChild(lista);
      g.appendChild(fundo); g.appendChild(painel);
      function fecha(ev) { if (ev) { ev.preventDefault(); ev.stopPropagation(); } self.fechaGaveta(); }
      fundo.addEventListener('click', fecha);
      x.addEventListener('click', fecha);
      document.body.appendChild(g);

      if (!celular) {
        var r = botao.getBoundingClientRect();
        var larg = Math.max(r.width, 260);
        painel.style.width = larg + 'px';
        painel.style.left = Math.max(8, Math.min(r.left, window.innerWidth - larg - 8)) + 'px';
        var abaixo = window.innerHeight - r.bottom;
        if (abaixo < 300 && r.top > abaixo) painel.style.bottom = (window.innerHeight - r.top + 6) + 'px';
        else painel.style.top = (r.bottom + 6) + 'px';
      } else {
        this.__overflowAntes = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }
      this.__gaveta = { el: g, botao: botao, celular: celular };
      botao.setAttribute('aria-expanded', 'true');
      this.__escGaveta = function (ev) { if (ev.key === 'Escape') self.fechaGaveta(); };
      this.__rolaGaveta = function () { if (!celular) self.fechaGaveta(); };
      document.addEventListener('keydown', this.__escGaveta);
      window.addEventListener('scroll', this.__rolaGaveta, { passive: true });
      window.addEventListener('resize', this.__rolaGaveta, { passive: true });
      var marcado = lista.querySelector('[aria-selected="true"]');
      if (marcado) { try { lista.scrollTop = Math.max(0, marcado.offsetTop - lista.clientHeight / 2 + marcado.offsetHeight / 2); } catch (e) {} }
      if (!celular) { try { (marcado || x).focus({ preventScroll: true }); } catch (e) {} }
    }

    fechaGaveta() {
      var g = this.__gaveta;
      if (!g) return;
      this.__gaveta = null;
      try { g.el.parentNode && g.el.parentNode.removeChild(g.el); } catch (e) {}
      if (g.celular) document.documentElement.style.overflow = this.__overflowAntes || '';
      try { g.botao.setAttribute('aria-expanded', 'false'); } catch (e) {}
      document.removeEventListener('keydown', this.__escGaveta);
      window.removeEventListener('scroll', this.__rolaGaveta);
      window.removeEventListener('resize', this.__rolaGaveta);
    }

    // a trava de modelo (capini-model-gate.js) marca <html data-capini-model-pendente>; a linha acompanha
    vigiaTravaDeModelo() {
      if (!this.querySelector('[data-ck-cores]') || !window.MutationObserver) return;
      var self = this, agenda = null;
      try {
        new MutationObserver(function () {
          clearTimeout(agenda);
          agenda = setTimeout(function () { try { self.syncHeroFromForm(); self.renderAll(); } catch (e) {} }, 40);
        }).observe(document.documentElement, { attributes: true, attributeFilter: ['data-capini-model-pendente'] });
      } catch (e) {}
    }

    /* O NUMERO DO DESCONTO NUNCA E DIGITADO — sai do metacampo que ja define o preco.
       Cravado 13/08/2026: o selo estava escrito "SAVE 25%" a mao. No dia em que a Ferrara
       entrar a 15%, um selo digitado vira mentira na pagina. Use {n} no texto do editor. */
    comN(txt) {
      return String(txt).replace(/\{n\}/g, String(this.descSegunda));
    }

    precoSegunda(item, ativos) {
      if (item.dataset.slot !== 'second' || !this.descSegunda) return null;
      var hero = this.querySelector('[data-ck-item][data-hero="true"]');
      if (!hero || hero.__on === false) return null;      // sem a 1a unidade nao existe 2a
      var v = this.variantOf(item);
      if (!v) return null;
      return Math.round(v.price * (100 - this.descSegunda) / 100);
    }

    /* --------------------------------------------------------------------------- calculo ----- */
    variantOf(item) {
      var id = item.__selected;
      var list = item.__variants || [];
      for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
      return list[0] || null;
    }

    tierTotals(tier) {
      var price = 0, compare = 0, missing = false;
      var ativos = this.itensAtivos(tier);
      var linhas = [];
      ativos.forEach(function (item) {
        var v = this.variantOf(item);
        if (!v) { missing = true; return; }
        var qty = Number(item.dataset.qty) || 1;
        var oferta = this.precoSegunda(item, ativos);
        if (oferta === null || oferta === undefined) oferta = this.dealPriceFor(item, ativos);
        var unit = oferta === null ? v.price : oferta;
        linhas.push({ item: item, v: v, qty: qty, unit: unit });
      }, this);

      /* ------------------------------------------------------------------------------------
         A SHOPIFY APLICA UM DESCONTO AUTOMATICO SO — e ela escolhe o de MAIOR valor.
         Medido no carrinho real em 13/08/2026 (nao e teoria, sao recibos):
           Milano x2 + pelicula ............ 2a unidade -EUR12,25 venceu a pelicula -EUR8,99
           Milano x2 + AirPods + pelicula .. pelicula FREE -EUR19,99 venceu a 2a unidade
         `combinesWith.productDiscounts: true` NAO muda isso — testado e revertido no mesmo dia.
         Antes desta trava a tela somava os dois e o caixa cobrava EUR8,99 a mais. Uma vitrine
         que mente no ultimo clique custa mais caro que uma oferta fraca.
         ⚠️ Se um dia a loja ganhar uma Shopify Function que empilhe de verdade, esta trava sai.
      ------------------------------------------------------------------------------------ */
      var melhor = null;
      linhas.forEach(function (l) {
        var econ = (l.v.price - l.unit) * l.qty;
        if (econ > 0 && (melhor === null || econ > melhor.econ)) melhor = { linha: l, econ: econ };
      });
      linhas.forEach(function (l) {
        if (melhor && l !== melhor.linha) l.unit = l.v.price;
        l.item.__unit = l.unit;
        price   += l.unit * l.qty;
        compare += (l.v.compare_at_price && l.v.compare_at_price > l.v.price ? l.v.compare_at_price : l.v.price) * l.qty;
      });

      var disc = Number(tier.dataset.discount) || 0;
      var finalPrice = disc > 0 ? Math.round(price * (100 - disc) / 100) : price;
      // se ha desconto de kit, a ancora e o preco cheio somado
      if (disc > 0 && compare < price) compare = price;

      return { price: finalPrice, base: price, compare: compare, missing: missing };
    }

    renderAll() {
      var self = this;
      var selectedTier = null;
      try { this.itensGaveta(); } catch (e) {}

      this.tiers.forEach(function (tier) {
        var radio = tier.querySelector('.capini-kit__radio');
        var on = radio && radio.checked;
        tier.classList.toggle('is-selected', !!on);
        if (on) selectedTier = tier;

        // o brinde entra ANTES da conta: senao a soma ignora o item que a tela promete
        self.aplicaBrindeObrigatorio(tier);

        // os totais rodam ANTES: sao eles que definem item.__unit (preco de oferta)
        var t = self.tierTotals(tier);

        // preco por item
        tier.querySelectorAll('[data-ck-item]').forEach(function (item) {
          var v = self.variantOf(item);
          // a pilula ativa acompanha o __selected (o casamento automatico troca por baixo)
          item.querySelectorAll('[data-ck-variant-pill]').forEach(function (pil) {
            pil.classList.toggle('is-active', Number(pil.dataset.variantId) === item.__selected);
          });
          // 10/09/2026: a lista do celular (select--alt) acompanha a mesma escolha
          var ckAlt = item.querySelector('.capini-kit__select--alt');
          if (ckAlt && item.__selected && ckAlt.value !== String(item.__selected)) ckAlt.value = String(item.__selected);
          // Item DESMARCADO nao pode herdar o preco do estado anterior — medido em 12/08:
          // tirava o AirPods e a pelicula, ja desmarcada, continuava dizendo FREE.
          // Agora a linha desmarcada mostra quanto ELA CUSTARIA se entrasse agora.
          if (self.checklist && item.__on === false && v) {
            var comEle = self.itensAtivos(tier).concat([item]);
            /* A 2a UNIDADE tambem precisa mostrar o preco de oferta quando esta DESMARCADA
               (13/08): so `dealPriceFor` era consultado aqui, entao a linha exibia EUR49,00
               cheio enquanto a frase logo abaixo prometia "Second one is 25% off". Preco e
               promessa na mesma linha, se contradizendo — visto na tela ao vivo. */
            var of = self.precoSegunda(item, comEle);
            if (of === null || of === undefined) of = self.dealPriceFor(item, comEle);
            item.__unit = (of === null || of === undefined) ? v.price : of;
          }

          var el = item.querySelector('[data-ck-item-price]');
          var mirror = item.querySelector('[data-ck-mirror]');
          if (mirror && v) mirror.textContent = v.title;

          /* A MINIATURA SEGUE A VARIANTE (12/08) — o Talles escolheu Dark Green e a foto continuou
             marrom. Numa loja de COR, mostrar a cor errada e pior que nao mostrar imagem nenhuma.
             So troca quando a variante tem foto propria; sem foto, mantem a do produto. */
          var mini = item.querySelector('.capini-kit__item-img');
          if (mini && v && v.img && mini.getAttribute('src') !== v.img) {
            mini.setAttribute('src', v.img);
          }

          /* GANCHO DO BRINDE (12/08) — o Talles: "nao esta claro que se a pessoa levar o AirPods,
             a pelicula vem de graca". Agora a propria linha ensina, nos dois sentidos:
               - na linha do PRESENTE  : "FREE if you add the AirPods case"
               - na linha do GATILHO   : "Includes a free screen protector"
             So aparece quando o par ainda NAO esta montado — cumprido, some. */
          var hook = item.querySelector('[data-ck-hook]');
          if (hook) {
            var txt = '';
            var pid = item.dataset.productId;
            var ehPresente = self.dealsOn && pid === self.dealProduct;      // a pelicula
            var ehGatilho  = self.dealsOn && pid === self.dealFreeTrig;      // o AirPods
            var gatilhoOn  = self.dealFreeTrig
              ? tier.querySelector('[data-ck-item][data-slot="main"][data-product-id="' + self.dealFreeTrig + '"]')
              : null;
            var gatilhoAtivo = !!(gatilhoOn && gatilhoOn.__on !== false);

            // a pelicula anuncia o PROPRIO desconto enquanto nao for brinde;
            // virou brinde, o selo FREE ja diz tudo e o gancho sai da frente.
            if (ehPresente && !gatilhoAtivo && self.txtGanchoFree) txt = self.txtGanchoFree;
            if (ehGatilho  && !gatilhoAtivo && self.txtGanchoLeva) txt = self.txtGanchoLeva;
            if (item.dataset.slot === 'second' && self.txtSegundaHook) txt = self.comN(self.txtSegundaHook);

            hook.textContent = txt;
            hook.hidden = !txt;
          }
          if (el && v) {
            var qty = Number(item.dataset.qty) || 1;
            var unit = (typeof item.__unit === 'number') ? item.__unit : v.price;
            if (unit < v.price) {
              // cada oferta tem o SEU selo: a 2a unidade herdava o da pelicula ("ONLY EUR11"),
            // que e de outra promocao. Visto na tela em 12/08.
            var selo;
            if (item.dataset.slot === 'second' && self.txtSegundaBadge) selo = self.comN(self.txtSegundaBadge);
            else selo = unit === 0 ? self.dealFreeBadge : self.dealBadge;
              el.innerHTML = '<s>' + formatMoney(v.price * qty, self.moneyFormat) + '</s> ' +
                             (unit === 0 ? '' : formatMoney(unit * qty, self.moneyFormat) + ' ') +
                             '<span class="capini-kit__deal">' + selo + '</span>';
            } else {
              el.innerHTML = formatMoney(v.price * qty, self.moneyFormat);
            }
          }
        });

        var priceEl   = tier.querySelector('[data-ck-price]');
        var compareEl = tier.querySelector('[data-ck-compare]');
        var saveEl    = tier.querySelector('[data-ck-save]');

        if (priceEl) priceEl.innerHTML = formatMoney(t.price, self.moneyFormat);

        var economia = t.compare - t.price;
        if (compareEl) {
          if (economia > 0) { compareEl.innerHTML = formatMoney(t.compare, self.moneyFormat); compareEl.hidden = false; }
          else { compareEl.hidden = true; }
        }
        if (saveEl) {
          if (economia > 0) { saveEl.innerHTML = self.txtSaveShort + ' ' + formatMoney(economia, self.moneyFormat); saveEl.hidden = false; }
          else { saveEl.hidden = true; }
        }

        // VALOR POR ITEM — K1 Anibal, Bloco 1: "ancoragem 3 -> 2 -> 1 e valor por item".
        // E o que faz o kit parecer melhor negocio SEM depender de desconto (AN-62).
        var perEl = tier.querySelector('[data-ck-per-item]');
        if (perEl) {
          var unidades = 0;
          tier.querySelectorAll('[data-ck-item]').forEach(function (item) {
            unidades += Number(item.dataset.qty) || 1;
          });
          if (unidades > 1) {
            perEl.innerHTML = formatMoney(Math.round(t.price / unidades), self.moneyFormat) + ' ' + self.txtPerItem;
            perEl.hidden = false;
          } else {
            perEl.hidden = true;
          }
        }
      });

      this.renderChoices();
      this.renderPanel();

      // rodape + CTA
      if (selectedTier) {
        var tt = this.tierTotals(selectedTier);
        if (this.ctaTotal) this.ctaTotal.innerHTML = formatMoney(tt.price, this.moneyFormat);
        var baseProg = this.progAfter ? tt.price : this.brutoDoTier(selectedTier);
        if (this.progStorePct > 0) baseProg = Math.round(baseProg * (100 - this.progStorePct) / 100);
        this.renderProgress(baseProg);
        if (this.checklist) {
          var n = this.itensAtivos(selectedTier).length;
          var lab = this.querySelector('[data-ck-cta-label]');
          var tpl = this.dataset.labelAddN || 'Add %n items';
          var txt = tpl.replace('%n', n).replace('{n}', n);
          // "Add 1 items" doia de ler. ATENCAO: em edicao anterior eu escrevi  dentro de
          // string Python e ele virou o caractere BACKSPACE no arquivo — o regex nunca casava.
          // Aqui a borda de palavra e escrita direto no JS, sem passar por escape de outra linguagem.
          if (n === 1) {
            txt = txt.replace(/items/i, 'item').replace(/itens/i, 'item');
          }
          if (lab) lab.textContent = txt;
        }
        if (this.footSave) {
          var eco = tt.compare - tt.price;
          if (eco > 0) { this.footSave.innerHTML = this.txtSave + ' ' + formatMoney(eco, this.moneyFormat); this.footSave.hidden = false; }
          else { this.footSave.hidden = true; }
        }
      }
    }

    /* ------------------------------------------------------------------ adicionar ao carrinho - */
    addToCart() {
      var self = this;
      if (this.busy) return;                       // trava de duplo-clique (medida 05/08)

      var tier = this.querySelector('.capini-kit__tier.is-selected') || this.tiers[0];
      if (!tier) return;

      var items = [];
      var incomplete = false;
      this.itensAtivos(tier).forEach(function (item) {
        var v = self.variantOf(item);
        if (!v || !v.available || item.__semVariante) { incomplete = true; return; }
        items.push({ id: v.id, quantity: Number(item.dataset.qty) || 1 });
      });

      if (!items.length || incomplete) {
        this.showError(this.txtErrPick);
        return;
      }

      this.busy = true;
      this.setLoading(true);
      this.hideError();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Erro'); });
          return r.json();
        })
        .then(function () {
          /* 13/08 — 30% das sessões do Clarity com ScriptError. Isolei no clique: quem estoura é
             `theme.s.min.js` ouvindo `cart:refresh` e lendo `.cart` de um null — a gaveta nativa do
             Impact não existe mais nesta loja, quem manda é o app AMP Slide Cart. O console
             culpava o capini-kit.js só porque o evento parte daqui.
             Com o app presente, o refresh certo é `SLIDECART_UPDATE()`; os eventos do tema viram
             pura rede de segurança para o dia em que o app sair. */
          var temApp = typeof window.SLIDECART_UPDATE === 'function'
                    || typeof window.SLIDECART_OPEN === 'function';
          if (!temApp) {
            try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
            try { document.dispatchEvent(new CustomEvent('cart:change',  { bubbles: true })); } catch (e) {}
          }
          self.afterAddAction();
        })
        .catch(function (err) {
          self.showError((err && err.message) || self.txtErrGen);
        })
        .then(function () {
          self.busy = false;
          self.setLoading(false);
        });
    }

    /* ------------------------------------------------------- ABRIR A GAVETA DE VERDADE ------
       12/08: o Talles perguntou "ao clicar em add to cart, deveria abrir o carrinho, nao?".
       Devia — e nao abria. Eu so disparava `cart:refresh`, que ATUALIZA a gaveta mas nao a ABRE.

       MEDIDO na pagina: a gaveta desta loja e o app AMP Slide Cart, que expoe
       `SLIDECART_OPEN()` / `SLIDECART_UPDATE()` no window. Uso a API dele quando existe e caio
       pros eventos do tema quando nao existe — se um dia o app sair, o kit continua funcionando.
    */
    abrirGaveta() {
      try {
        if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
        if (typeof window.SLIDECART_OPEN === 'function') {
          setTimeout(function () { try { window.SLIDECART_OPEN(); } catch (e) {} }, 120);
          return true;
        }
      } catch (e) {}

      // gaveta nativa do tema (Impact) — funciona se o app for desligado
      try {
        var d = document.querySelector('cart-drawer, #cart-drawer');
        if (d && typeof d.show === 'function') { d.show(); return true; }
        if (d && typeof d.open === 'function') { d.open(); return true; }
      } catch (e) {}

      return false;
    }

    afterAddAction() {
      if (this.afterAdd === 'checkout') { window.location.href = '/checkout'; return; }
      if (this.afterAdd === 'cart')     { window.location.href = this.cartUrl; return; }
      if (this.afterAdd === 'stay')     { this.flash(); return; }

      var abriu = this.abrirGaveta();
      if (!abriu) this.flash();     // sem gaveta, ao menos confirma na tela
      else this.flash();
    }

    flash() {
      var self = this;
      if (!this.cta) return;
      var label = this.querySelector('[data-ck-cta-label]');
      if (!label) return;
      // guarda o rotulo ORIGINAL uma vez so. Sem isso, o 2o clique lia "Added ✓" como original
      // e escrevia "Added ✓ ✓" (visto na tela em 12/08).
      if (this.__ctaLabelOriginal == null) this.__ctaLabelOriginal = label.textContent;
      var old = this.__ctaLabelOriginal;
      label.textContent = this.txtAdded;   // o check faz parte do texto do editor, nao do codigo
      this.cta.classList.add('is-done');
      setTimeout(function () { label.textContent = old; self.cta.classList.remove('is-done'); }, 2200);
    }

    setLoading(on) {
      if (!this.cta) return;
      this.cta.classList.toggle('is-loading', !!on);
      if ('disabled' in this.cta) this.cta.disabled = !!on;                    // aqui O BOTAO DESABILITA de verdade
    }

    showError(msg) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
    }

    hideError() {
      if (this.errorEl) this.errorEl.hidden = true;
    }
  }

  try {
    if (!customElements.get('capini-kit')) customElements.define('capini-kit', CapiniKit);
  } catch (e) { /* navegador sem custom elements: os tiers ficam visiveis, so nao calculam */ }
})();
